import {
    CREATE_PAYMENT_PAGE_REQUEST,
    CREATE_PAYMENT_PAGE_SUCCESS,
    CREATE_PAYMENT_PAGE_ERROR,
    GET_PAYMENT_PAGE_DETAILS_REQUEST,
    GET_PAYMENT_PAGE_DETAILS_SUCCESS,
    GET_PAYMENT_PAGE_DETAILS_ERROR,
    UPDATE_PAYMENT_PAGE_DETAILS_REQUEST,
    UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS,
    UPDATE_PAYMENT_PAGE_DETAILS_ERROR,
    SHOW_PAYMENT_PAGE_LOADER,
    HIDE_PAYMENT_PAGE_LOADER,
    FETCH_PAYMENT_PAGE_ERROR,
    FETCH_PAYMENT_PAGE_REQUEST,
    FETCH_PAYMENT_PAGE_SUCCESS,
    FETCH_TRANSACTION_PAYMENT_REQUEST,
    FETCH_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_TRANSACTION_PAYMENT_ERROR,
    VIEW_PAY_LINK_ERROR,
    VIEW_PAY_LINK_REQUEST,
    VIEW_PAY_LINK_SUCCESS,
    RE_SHARE_PAY_PAGE_ERROR,
    RE_SHARE_PAY_PAGE_REQUEST,
    RE_SHARE_PAY_PAGE_SUCCESS,
    GENERATE_REPORT_ERROR_PAYMENT_PAGE,
    GENERATE_REPORT_REQUEST_PAYMENT_PAGE,
    GENERATE_REPORT_SUCCESS_PAYMENT_PAGE,
} from './paymentPage.constants';

export const fetchPaymentPageRequest = payload => ({
    type: FETCH_PAYMENT_PAGE_REQUEST,
    payload,
});

export const fetchPaymentPageSuccess = payload => ({
    type: FETCH_PAYMENT_PAGE_SUCCESS,
    payload,
});

export const fetchPaymentPageError = payload => ({
    type: FETCH_PAYMENT_PAGE_ERROR,
    payload,
});

export const createPaymentPageRequest = (
    payload,
    handleSuccessClick,
    status,
    history
) => {
    return {
        type: CREATE_PAYMENT_PAGE_REQUEST,
        payload,
        handleSuccessClick,
        status,
        history,
    };
};

export const createPaymentPageSuccess = payload => ({
    type: CREATE_PAYMENT_PAGE_SUCCESS,
    payload,
});

export const createPaymentPageError = payload => ({
    type: CREATE_PAYMENT_PAGE_ERROR,
    payload,
});

export const getPaymentPageDetailsRequest = payload => {
    console.log('Payload:', payload);
    return {
        type: GET_PAYMENT_PAGE_DETAILS_REQUEST,
        payload,
    };
};

// export const getPaymentPageDetailsSuccess = payload => ({
//     type: GET_PAYMENT_PAGE_DETAILS_SUCCESS,
//     payload,
// });
export const getPaymentPageDetailsSuccess = payload => {
    console.log('Payload in actions of get api :', payload);
    return {
        type: GET_PAYMENT_PAGE_DETAILS_SUCCESS,
        payload,
    };
};

export const getPaymentPageDetailsError = payload => ({
    type: GET_PAYMENT_PAGE_DETAILS_ERROR,
    payload,
});
export const updatePaymentPageDetailsRequest = (
    payload,
    history,
    status,
    handleSuccessClick
) => ({
    type: UPDATE_PAYMENT_PAGE_DETAILS_REQUEST,
    payload,
    history,
    status,
    handleSuccessClick
});

export const updatePaymentPageDetailsSuccess = payload => ({
    type: UPDATE_PAYMENT_PAGE_DETAILS_SUCCESS,
    payload,
});

export const updatePaymentPageDetailsError = payload => ({
    type: UPDATE_PAYMENT_PAGE_DETAILS_ERROR,
    payload,
});

export const fetchPaymentsRequest = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_REQUEST,
    payload,
});

export const fetchPaymentsSuccess = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_SUCCESS,
    payload,
});

export const fetchPaymentsError = payload => ({
    type: FETCH_TRANSACTION_PAYMENT_ERROR,
    payload,
});

// View Summary action for payment link transaction view table
export const viewPayLinksRequest = payload => ({
    type: VIEW_PAY_LINK_REQUEST,
    payload,
});

export const viewPayLinksSuccess = payload => ({
    type: VIEW_PAY_LINK_SUCCESS,
    payload,
});

export const viewPayLinksError = payload => ({
    type: VIEW_PAY_LINK_ERROR,
    payload,
});

export const reSharePayLinksRequest = payload => ({
    type: RE_SHARE_PAY_PAGE_REQUEST,
    payload,
});

export const reSharePayLinksSuccess = payload => ({
    type: RE_SHARE_PAY_PAGE_SUCCESS,
    payload,
});

export const reSharePayLinksError = payload => ({
    type: RE_SHARE_PAY_PAGE_ERROR,
    payload,
});

export const generateReportRequest = payload => ({
    type: GENERATE_REPORT_REQUEST_PAYMENT_PAGE,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_REPORT_SUCCESS_PAYMENT_PAGE,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_REPORT_ERROR_PAYMENT_PAGE,
    payload,
});

export const showLoader = () => ({ type: SHOW_PAYMENT_PAGE_LOADER });

export const hideLoader = () => ({ type: HIDE_PAYMENT_PAGE_LOADER });
